import Decimal from 'decimal.js';

import getSafePointsStoredValue from '@/utils/getSafePointsStoredValue';
import getPointsFraction from './getPointsFraction';

interface GetFlightCharge {
  points: {
    [key: string]: number;
  };
  offerId?: string;
  currentTotalAmount: number | string;
  additionalAmount: number | string;
  currentAdditionalAmount: number | string;
}

export const getFlightChargeData = ({
  points,
  offerId,
  currentTotalAmount,
  additionalAmount,
  currentAdditionalAmount,
}: GetFlightCharge): {
  currentFraction: number;
  newAmount: number;
  newFraction: number;
} => {
  const fraction =
    points &&
    offerId &&
    currentTotalAmount &&
    getSafePointsStoredValue(points, offerId, currentTotalAmount);

  // Difference in flight price, in $. eg 500.00
  const diff = Decimal.sub(additionalAmount, currentAdditionalAmount);

  // eg. currentTotalAmount is 2000.00 ($total). diff is 500.00 ($flight)
  const newAmount = Decimal.add(currentTotalAmount, diff)
    .toDecimalPlaces(2, Decimal.ROUND_HALF_EVEN)
    .toNumber();

  const newFraction = getPointsFraction({
    currentTotalAmount,
    currentFraction: fraction || 1, // This is a fail-safe, we should in always have a curent fraction at this point
    newTotalAmount: newAmount,
  });

  return {
    currentFraction: fraction as number, // The current fraction in sessionStorage, based on the offerId and currentAmount
    newFraction, // The new amount, based on current amount + additionalAmount
    newAmount, // The new fraction, based on the new amount.
  };
};
